// ── View-as API client (ClientApp/src/api/viewAs.ts) ──
// Lets a user preview the app with some of their own roles removed. The suppression is applied
// server-side by a claims transformation, so what comes back from the API is what a user without
// those roles would genuinely receive — not a hidden UI over a still-privileged session.

import { putJson } from './client';

export interface ViewAsState {
  /** True while at least one role is suppressed. */
  active: boolean;
  suppressedRoles: string[];
  /** Every role the caller would hold with nothing suppressed. Survives suppressing them all. */
  availableRoles: string[];
}

/**
 * Replaces the suppressed-role selection. Passing an empty array exits the preview — there is no
 * separate "clear" call, so exiting cannot drift from entering.
 */
export function setViewAs(suppressedRoles: string[]): Promise<ViewAsState> {
  return putJson<ViewAsState>('/api/auth/view-as', { suppressedRoles });
}
